export enum AssetAllocationViewMode {
  Performance = 'performance',
  Holdings = 'holdings',
  All = 'all',
}
